import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { EMessageType } from 'src/app/shared/data/response-default.interface';
import { ToastService } from 'src/app/shared/services/toast.service';

@Component({
  selector: 'app-add-categoria',
  templateUrl: './add-categoria.component.html',
  styleUrls: ['./add-categoria.component.scss']
})
export class AddCategoriaComponent {

  @Output() recarregarListagem = new EventEmitter();
  fecharAddCategoria = false;
  formAberto = false;

  formCategoria = new UntypedFormGroup({
    name: new UntypedFormControl('', [Validators.required]),
    decription: new UntypedFormControl('', [Validators.required])

  });

  constructor(private readonly toastService: ToastService,
  ) { }

  // ngOnInit() {
  // }

  public salvarCategoria(): void {
    if (this.formCategoria.invalid) {
      this.toastService.toast("Both fields are required and it's minimum length is 4 characters.", EMessageType.Error);
      return;
    }
  }
  hideModal(): void {
    this.fecharAddCategoria = true;
  }
}
